export const ALL_USERS = "ALL_USERS";

export interface Email {
	type: "Email";
	value: string;
}

export interface DocPermRequest {
	userType: "AllUsers" | "Username" | "Email";
	relation: "reader";
	value: string;
}
